import { render, staticRenderFns } from "./planA.vue?vue&type=template&id=1b93349d&scoped=true&"
import script from "./planA.vue?vue&type=script&lang=js&"
export * from "./planA.vue?vue&type=script&lang=js&"
import style0 from "./planA.vue?vue&type=style&index=0&id=1b93349d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93349d",
  null
  
)

export default component.exports